import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, shareReplay } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { CodigoArticuloGastoDtoOut } from '../../models/maestros/codigoArticuloGasto.model';

@Injectable({
  providedIn: 'root',
})
export class CodigoArticuloGastoService {
  private readonly apiUrl = environment.apiUrl;
  private readonly endpoint = `${this.apiUrl}/contabilidad-maestros/gastos-articulos-proveedor`;

  private codigosArticulos?: Observable<CodigoArticuloGastoDtoOut[]>;

  constructor(private readonly http: HttpClient) {}

  getCodigosArticulos(): Observable<CodigoArticuloGastoDtoOut[]> {
    if (!this.codigosArticulos) {
      this.codigosArticulos = this.http.get<CodigoArticuloGastoDtoOut[]>(this.endpoint).pipe(
        shareReplay(1), // Uncomment if you want to cache the response
        catchError((error) => {
          console.error('CodigoArticuloGastoService - Error fetching data:', error);
          throw error;
        })
      );
    }

    return this.codigosArticulos;
  }
}
